<div class="modal" *ngIf="!sessionService.loggedIn()">
	<div class="modal-wrap animated">
		<div class="modal-content">
			<div class="modal-guest-login-wrapper">
				<!-- <app-guest-login (mouseover)="disableScroll(true)" (mouseout)="disableScroll(false)" ></app-guest-login> -->
				  <app-login></app-login>
			</div>
		</div>
	</div>
</div>